import { Component } from '@angular/core';

@Component({
  selector: 'portal-select-brand',
  templateUrl: './select-brand.component.html',
  standalone: false
})
export class SelectBrandComponent {}
